import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { OPS_SUB_ROLES } from '@/utils/constants/roles';

type RoleSwitcherProps = {
  activeRole: string;
  isRoleSwitching: boolean;
  onSwitchRole: (role: string, onSettled?: () => void) => void;
};

export default function RoleSwitcher({
  activeRole,
  isRoleSwitching,
  onSwitchRole,
}: RoleSwitcherProps) {
  const [selectedRole, setSelectedRole] = useState<string | null>(null);

  const displayRole = selectedRole ?? activeRole;

  const handleRoleSwitch = (value: string) => () => {
    setSelectedRole(value);
    onSwitchRole(value, () => setSelectedRole(null));
  };

  return (
    <div className="bg-role-switcher-bg flex items-center gap-1 rounded-full p-1">
      {OPS_SUB_ROLES.map(({ label, value }) => {
        const isActive = value === displayRole.toLowerCase();

        return (
          <Button
            key={value}
            type="button"
            size="sm"
            onClick={handleRoleSwitch(value)}
            aria-pressed={isActive}
            className={cn(
              'h-8 rounded-full border-none bg-transparent px-4 text-sm font-semibold text-white shadow-none transition-none outline-none hover:bg-transparent hover:text-white focus-visible:ring-0 focus-visible:ring-offset-0',
              {
                'text-primary hover:text-primary bg-white hover:bg-white': isActive,
                'pointer-events-none cursor-not-allowed opacity-50': isRoleSwitching && !isActive,
              }
            )}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
}
